import { useState, useEffect } from "react";
import { EntriesApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";
import { useTranslation } from "i18n-fe";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useEntry(entryId) {
  const auth = useAuth();
  const { t } = useTranslation("common");
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!entryId) {
      setEntry(null);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchEntry = async () => {
      if (!auth.user?.access_token) {
        setError(t("shows.detail.authError"));
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const api = new EntriesApi(
          new Configuration({
            basePath: MANAGER_API_BASE_URL,
            accessToken: auth.user.access_token,
          })
        );
        const { data } = await api.getEntry(entryId);
        setEntry(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching entry:", err);
        setError(t("shows.detail.error"));
      } finally {
        setLoading(false);
      }
    };

    fetchEntry();
  }, [entryId, auth.user, t]);

  return { entry, loading, error };
}
